import { DOCUMENT_DISPLAY_UOM_SELECT_DATA } from "~/shared/documents/display-uom-select-options";
import type { DocumentDisplayUomSettings } from "~/shared/documents/schemas/document-display-uom.schema";
import { Select, Stack, Switch, Text, type UseFormReturnType } from "~/ui";

type DocumentDisplayUomSettingsFieldsProps<T extends DocumentDisplayUomSettings> = {
  form: UseFormReturnType<T>;
  canEdit: boolean;
  /** Shown on the override switch — e.g. "Create Bill of Lading modal". */
  createModalLabel: string;
  /** When false, hide the create-modal override switch (setting not yet wired on create form). */
  createModalOverrideSupported?: boolean;
};

/** Shared display UOM org defaults for document PDF settings (SC-2494). */
export const DocumentDisplayUomSettingsFields = <T extends DocumentDisplayUomSettings>({
  form,
  canEdit,
  createModalLabel,
  createModalOverrideSupported = true,
}: DocumentDisplayUomSettingsFieldsProps<T>) => (
  <Stack spacing="xs">
    <Select
      label="Display unit of measure"
      description="Controls quantity and weight labels on the PDF. Product default uses packaging labels; choose KG for kilograms."
      data={[...DOCUMENT_DISPLAY_UOM_SELECT_DATA]}
      disabled={!canEdit}
      {...form.getInputProps("displayUom")}
    />
    {createModalOverrideSupported ? (
      <Switch
        label={`Allow display UOM override on ${createModalLabel}`}
        description="When enabled, brokers can choose product default, lb, or kg when generating the document."
        disabled={!canEdit}
        {...form.getInputProps("allowDisplayUomOverrideOnCreate", { type: "checkbox" })}
      />
    ) : (
      <Text size="sm" color="dimmed">
        Create-modal display UOM override is not yet available for this document type; org default applies.
      </Text>
    )}
  </Stack>
);
